/** Body class while a jQuery-draggable item is in flight. */ const FOLDER_TREE_DRAGGING_BODY_CLASS = "aiot-currently-dragging";
/**
 * Body class toggled while any key is held during drag — switches move vs copy/append mode.
 * Matches `.aiot-helper` SCSS in `style/style.scss`.
 */ const FOLDER_TREE_DRAG_APPEND_BODY_CLASS = "aiot-helper-method-append";
/** Inner helper panels rendered inside `.aiot-helper`. */ const FOLDER_TREE_DRAG_MOVE_HELPER_CLASS = "aiot-helper-method-move";
const FOLDER_TREE_DRAG_APPEND_HELPER_CLASS = "aiot-helper-method-append";
function parseFolderTreeDropTarget($, event) {
    const $target = $(event.target);
    const toTmp = $target.attr("data-id");
    const to = toTmp === "all" || toTmp === undefined || toTmp === "" ? toTmp ?? "" : +toTmp;
    const $tree = $target.closest(".aiot-tree");
    return {
        to,
        folderName: $target.find(".aiot-node-name").html(),
        treeAttributes: {
            tax: $tree.attr("data-tax"),
            type: $tree.attr("data-type")
        }
    };
}
function isFolderTreeDragCopyMode($) {
    return $("body").hasClass(FOLDER_TREE_DRAG_APPEND_BODY_CLASS);
}
function bindFolderTreeDragCopyMode($) {
    const keyDown = ()=>$("body").addClass(FOLDER_TREE_DRAG_APPEND_BODY_CLASS);
    const keyUp = ()=>$("body").removeClass(FOLDER_TREE_DRAG_APPEND_BODY_CLASS);
    $(document).on("keydown", keyDown);
    $(document).on("keyup", keyUp);
    keyUp();
    return ()=>{
        $(document).off("keydown", keyDown);
        $(document).off("keyup", keyUp);
    };
}
function setFolderTreeDragging($, dragging) {
    $("body").toggleClass(FOLDER_TREE_DRAGGING_BODY_CLASS, dragging);
}
async function runFolderTreeDrop({ $, event, ui, collect, onBefore, execute, onSuccess, onError, onFinally }) {
    const { to, folderName, treeAttributes } = parseFolderTreeDropTarget($, event);
    const payload = {
        ...collect(ui),
        to,
        isCopy: isFolderTreeDragCopyMode($),
        folderName,
        treeAttributes
    };
    onBefore?.(payload);
    try {
        await execute(payload);
        onSuccess?.(payload);
    } catch (error) {
        onError?.(error, payload);
        if (!onError) {
            throw error;
        }
    } finally{
        onFinally?.(payload);
    }
}
export { bindFolderTreeDragCopyMode, FOLDER_TREE_DRAG_APPEND_BODY_CLASS, FOLDER_TREE_DRAG_APPEND_HELPER_CLASS, FOLDER_TREE_DRAG_MOVE_HELPER_CLASS, FOLDER_TREE_DRAGGING_BODY_CLASS, isFolderTreeDragCopyMode, parseFolderTreeDropTarget, runFolderTreeDrop, setFolderTreeDragging };
